export default "__VITE_ASSET__QEysBAFS__"